<div *ngIf="item.subItems.length > 0">
  <p class="mb-3 mt-0">
    <b class="bom-hierarchy-item__title">{{ item.title }}</b>
    <bom-info-icon
      *ngIf="item.showInfoIcon"
      (invokedEvent)="clickInfoIcon.emit(item)"
      [content$]="info$"
    ></bom-info-icon>
  </p>
  <p class="my-0" [innerHTML]="item.description"></p>
  <div *ngFor="let subItem of item.subItems">
    <div class="ml-6 my-5">
      <bom-hierarchy-item
        [item]="subItem"
        [addedItemIds$]="addedItemIds$"
        [isAddDisabled$]="isAddDisabled$"
        [infos$]="infos$"
        [addButtonTextKey]="addButtonTextKey"
        (clickAdd)="clickAdd.emit($event)"
        (clickInfoIcon)="clickInfoIcon.emit($event)"
      ></bom-hierarchy-item>
    </div>
  </div>
</div>

<div *ngIf="item.subItems.length === 0">
  <div class="row align-items-center">
    <div class="col">
      <p class="mb-3 mt-0">
        <b class="bom-hierarchy-item__title">{{ item.title }}</b>
        <bom-info-icon
          *ngIf="item.showInfoIcon"
          (invokedEvent)="clickInfoIcon.emit(item)"
          [content$]="info$"
        ></bom-info-icon>
      </p>
      <p class="my-0" [innerHTML]="item.description"></p>
    </div>
    <div class="col-auto">
      <div class="d-flex align-items-center">
        <ng-container *ngIf="!(isAdded$ | async); else showAdded">
          <button
            class="button button-secondary ml-3 test-hierarchy-item-add"
            [disabled]="isAddDisabled$ | async"
            (click)="clickAdd.emit(item)"
          >
            {{ addButtonTextKey | tekstresource }}
          </button>
        </ng-container>
        <ng-template #showAdded>
          <span class="pr-4">{{
            (addButtonTextKey === 'Add' ? 'Added' : 'Chosen') | tekstresource
          }}</span>
        </ng-template>
      </div>
    </div>
  </div>
</div>
